class MixedCheckbox extends Checkbox {
    constructor(label: string, controller: Controller, oldContainer: JQuery, checkboxGroup: CheckboxGroup, mode: string) {
        super(oldContainer.attr("value"), label, controller, oldContainer, checkboxGroup, mode);
    }

    initHTML(oldElement, label) {
        var newHTML = '';

        newHTML += '<div class="check_option">';
        newHTML += '    <div class="layers">';
        newHTML += '        <div class="check_option_circle layer1">';
        newHTML += '            <div class="checkmark">&#10004;</div>';
        newHTML += '        </div>';
        newHTML += '        <div class="check_option_circle layer2 hidden"></div>';
        newHTML += '    </div>';
        newHTML += '    <div class="check_option_label">' + label + '</div>';
        newHTML += '</div>';

        this.container = $(newHTML);

        oldElement.replaceWith(this.container);
    }

   setEnabled (enabled) {
        this.container.toggleClass("disabled", enabled);
    }

   previewEnabled (enabled) {

    }

   isEnabled() {
        return !this.container.hasClass("disabled");
    }

   setVisible(visible) {
        console.log("TODO: implement setVisible() in all radioButtons");
    }

   previewVisible (visible) {
        // Default UI has no feedforward
    }

   setSelected (selected) {
        this.container.toggleClass("selected", selected);
    }

   isSelected() {
        return this.container.hasClass("selected");
    }

   previewSelected (selected) {
        this.container.find(".layer2").toggleClass("selected", selected);
        this.container.find(".layer2").removeClass("hidden");
    }

    removePreviewEnabled() {
        // TODO
    }

    removePreviewSelected() {
        this.container.find(".layer2").addClass("hidden");
    }
}